/**
 * Text Field Component Renderer
 *
 * Renders text field components with loading state support and event handling.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
/**
 * Allowed props for uo-text-field component
 */
const uoTextFieldAllowedProps = new Set([
    'id',
    'name',
    'type',
    'value',
    'label',
    'placeholder',
    'helper',
    'required',
    'disabled',
    'auto-focus',
    'copy-to-clipboard'
]);
/**
 * Render a text field component
 *
 * @param {TextFieldProps & { loading?: boolean }} data - The text field data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered text field component
 */
export function textFieldRenderer(data, props = {}) {
    const { '@change': changeHandler, ...textFieldProps } = data;
    const { loading, ...restProps } = props;
    if (loading) {
        return html `
			<uo-placeholder height="34px" width="100px"></uo-placeholder>
		`;
    }
    return html `
		<uo-text-field
			${spreadProps(uoTextFieldAllowedProps)({ ...textFieldProps, ...restProps })}
			${changeHandler ? `@change=${changeHandler}` : ''}
		></uo-text-field>
	`;
}
